interface GlobalNegotiationPermission {
  customerCode: string;
  negotiationFields: string[];
}

export interface GlobalPermissions {
  negotiationConfigurations?: GlobalNegotiationPermission[];
}

let globalPermissions: GlobalPermissions = {};

export enum AvaliablePermissions {
  CHANGE_REQUEST_UNIT_PRICE = 'Negotiation.ChangeRequest.UnitPrice',
  CHANGE_REQUEST_REQUESTED_DATE = 'Negotiation.ChangeRequest.RequestedDate',
  CHANGE_REQUEST_QUANTITY = 'Negotiation.ChangeRequest.Quantity'
}

export const initializeGlobalPermissions = (permissions: GlobalPermissions) => {
  globalPermissions = { ...permissions };
};

export const getNegotiationPermissions = (customerCode: string): string[] => {
  if (!globalPermissions.negotiationConfigurations) {
    return [];
  }

  const config = globalPermissions.negotiationConfigurations.find(e => e.customerCode === customerCode);

  if (!config) {
    return [];
  }

  return [...config.negotiationFields];
};

export const hasNegotiationPermission = (customerCode: string, permissionName: string) => {
  return getNegotiationPermissions(customerCode).indexOf(permissionName) !== -1;
};
